// main.tsx
import "./ag-grid-license";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@multiconsult-group/core/styles.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";

import { store } from "./app/store";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import { msalInstance } from "./msalInstance";
import "ag-grid-enterprise";
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-enterprise";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";


async function boot() {
  // Initiera MSAL och hantera ev. redirect-svar innan render
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const container = document.getElementById("root");
  if (!container) throw new Error("#root saknas");

  // Registrera alla AG Grid-moduler globalt (en gång!)
  ModuleRegistry.registerModules([AllEnterpriseModule]);

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
            <MantineProvider>
              <ModalsProvider>
                <App />
              </ModalsProvider>
            </MantineProvider>
          </MsalProvider>
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

boot().catch((e) => {
  console.error("MSAL boot failed:", e);
  const el = document.getElementById("root");
  if (el) el.innerHTML = "<pre>Auth init failed</pre>";
});
